module.exports = __webpack_public_path__ + "static/location-info3-eb92f359e3568f17ecf02cd59fb5ee5f.jpg";